import { createFileRoute } from '@tanstack/react-router'
import { AboutPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/fr/a-propos')({
  loader: () => loadPageData({ data: { kind: 'about', locale: 'fr' } }),
  head: () => staticRouteHead('about', 'fr'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <AboutPage />
    </CatalogProvider>
  )
}
